// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnersContentEntityMapper$PorterinFeature from "../entity-mapper/PartnersContentEntityMapper.mjs";
import * as ResponseHandler$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ResponseHandler.mjs";
import * as PartnerFormResponseEntityMapper$PorterinFeature from "../entity-mapper/PartnerFormResponseEntityMapper.mjs";
import * as PartnerVehicleTypesEntityMapper$PorterinFeature from "../entity-mapper/PartnerVehicleTypesEntityMapper.mjs";

var execute = PartnersContentEntityMapper$PorterinFeature.execute;

var PartnersContentApiConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PartnersContentApiResponseConverter = partial_arg(PartnersContentApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$1 = PartnerVehicleTypesEntityMapper$PorterinFeature.execute;

var PartnerVehiclesApiConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PartnerVehiclesApiResponseConverter = partial_arg$1(PartnerVehiclesApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

var execute$2 = PartnerFormResponseEntityMapper$PorterinFeature.execute;

var PartnerFormApiConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$PorterinFusionkitNetworkUtils.ResponseConverter;

var PartnerFormApiResponseConverter = partial_arg$2(PartnerFormApiConfig, ResponseHandler$PorterinFusionkitNetworkUtils.DefaultErrorConverter);

export {
  PartnersContentApiConfig ,
  PartnersContentApiResponseConverter ,
  PartnerVehiclesApiConfig ,
  PartnerVehiclesApiResponseConverter ,
  PartnerFormApiConfig ,
  PartnerFormApiResponseConverter ,
}
/* PartnersContentApiResponseConverter Not a pure module */
